module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZGUyMTEwIiBkPSJNMCAzMTkuOTk3aDY0MFY0ODBIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoNjQwdjE2MC4wMDNIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiMzMTk0MDAiIGQ9Ik0wIDE2MC4wMDNoNjQwdjE2MC4wMDNIMHoiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/bg.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/bg.svg
// module chunks = 0